import { render, staticRenderFns } from "./IconContentProvider.vue?vue&type=template&id=48d57dec"
import script from "./IconContentProvider.vue?vue&type=script&lang=js"
export * from "./IconContentProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports